import { render, staticRenderFns } from "./SettlementStatusChip.vue?vue&type=template&id=8c4965a0&"
import script from "./SettlementStatusChip.vue?vue&type=script&lang=js&"
export * from "./SettlementStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports